import React from 'react'
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({sysadmin, authenticationRequired, authorizationRequired,
  onlyadmin, onlycashier, cashierAllowed, children, sysandadmin}) => {

  const isAuthenticated = sessionStorage.getItem('token') !== null;
  const userRole = sessionStorage.getItem('role'); 

  if (authenticationRequired && !isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (authorizationRequired) {
    if(userRole === "CASHIER" && !cashierAllowed) {
      return <Navigate to="/unauthorized" />;
    } else if(userRole === null) {
      return <Navigate to="/login" />;
    }
  }

  if(onlyadmin && userRole === "CASHIER" && !cashierAllowed){
    return <Navigate to="/unauthorized" />;
  }

  if(sysadmin && (userRole === "CASHIER" || userRole === "ADMIN")){
    return <Navigate to="/unauthorized" />;
  } 

  if(onlycashier && userRole === "ADMIN"){
    return <Navigate to="/unauthorized" />;
  } 

  if(sysandadmin && (userRole !== "ADMIN" && userRole !== "SYSADMIN")) {
    return <Navigate to="/unauthorized" />;
  }

  return <>{children}</>;
}

export default PrivateRoute;